import { Button, FlexBox, InputText } from '@dixa/lib-shared-habla';
import { UploadMenu } from 'articleEditor/components/uploadMenu';
import { UseFloatingMenuReturn } from 'articleEditor/hooks/useFloatingMenu';
import {
  findNodePath,
  focusEditor,
  isUrl,
  setNodes,
} from 'lib-knowledge-document-structure/plate/common';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { MyImageElement } from 'lib-knowledge-document-structure/plateTypes';
import { useState } from 'react';

type ImageLinkMenuProps = {
  element: MyImageElement;
  floatingLinkMenu: UseFloatingMenuReturn;
};

export function ImageLinkMenu({
  element,
  floatingLinkMenu,
}: ImageLinkMenuProps): JSX.Element {
  if (!floatingLinkMenu.showFloatingMenu) return <></>;

  return (
    <UploadMenu
      floatingProps={{ ...floatingLinkMenu.floatingResult, isOpen: true }}
      getFloatingProps={floatingLinkMenu.getFloatingMenuProps}
    >
      <ImageLink
        closeLinkMenu={floatingLinkMenu.closeFloatingMenu}
        element={element}
      />
    </UploadMenu>
  );
}

type ImageLinkProps = {
  element: MyImageElement;
  closeLinkMenu: () => void;
};

function ImageLink({ element, closeLinkMenu }: ImageLinkProps): JSX.Element {
  const [linkUrl, setLinkUrl] = useState(element.linkUrl ?? '');
  const editor = useMyEditorRef();
  const isUrlValid = isUrl(linkUrl);

  const onAddLink = () => {
    const path = findNodePath(editor, element);
    setNodes(editor, { linkUrl }, { at: path });

    // Give the DOM a chance to update
    setTimeout(() => {
      closeLinkMenu();

      focusEditor(editor, editor.selection!);
    }, 50);
  };

  const onRemoveLink = () => {
    const path = findNodePath(editor, element);
    setNodes(editor, { linkUrl: '' }, { at: path });

    // Give the DOM a chance to update
    setTimeout(() => {
      closeLinkMenu();

      focusEditor(editor, editor.selection!);
    }, 50);
  };

  return (
    <FlexBox flexDirection="column" gap="400" padding="400">
      <InputText
        placeholder="Link URL"
        value={linkUrl}
        onChange={(e) => setLinkUrl(e.target.value)}
      />

      <FlexBox gap="200">
        {element.linkUrl && (
          <Button
            onClick={onRemoveLink}
            style={{ height: '40px' }}
            variant="secondary"
          >
            Remove Link
          </Button>
        )}

        <Button
          onClick={closeLinkMenu}
          style={{ marginLeft: 'auto', height: '40px' }}
          variant="secondary"
        >
          Cancel
        </Button>

        <Button
          disabled={!isUrlValid}
          onClick={onAddLink}
          style={{ height: '40px' }}
        >
          Link
        </Button>
      </FlexBox>
    </FlexBox>
  );
}
